export { setNonce } from '@stencil/core';
import { bootstrapLazy } from '@stencil/core';
import { globalScripts } from '@stencil/core/internal/app-globals';
export const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  globalScripts();
  return bootstrapLazy([/*!__STENCIL_LAZY_DATA__*/], options);
};
